'use strict';

var lang = require('./lang'),
  filters = require('./filters');

module.exports = {
  GLOBAL: {
    messages: lang.i18n.OTHER_MESSAGES,
    FONT_FAMILY: 'MyWebFont',
    DEFAULT_DURATION_DAYS: 'month',
    COLORS: {
      MOJO_BLUE: '#78a5c8',
      MOJO_DARK_GREY: '#41414b',
      MOJO_BLACK: '#0a0a0f',
      MOJO_WHITE: '#ffffff',
      MOJO_GREY: '#bebec3',
      MOJO_LIGHT_GREY: '#e6e6eb',
      MOJO_OFF_WHITE: '#f5f5fa',
      MOJO_TEAL: '#32e6f5',
      MOJO_RED: '#e6465a',
      MOJO_PURPLE: '#5a46b4',
      CHART_BLUE: '#41b6c4',
      CHART_RED: '#ec6c50',
      CHART_GREEN: '#74c476',
      CHART_MAROON: '#ce6064',
      CHART_BROWN: '#A0522D',
      RANGE6: '#668bcf',
      RANGE7: '#858282',
      RANGE8: '#8c83d4',
      RANGE9: '#f48e57',
      RANGE10: '#b837ba',
      RANGE11: '#ed4978',
      MALE: '#41b6c4',
      FEMALE: '#ec6c50',
      UNSPECIFIED: '#858282',
      BELOW15: '#668bcf',
      BETWEEN15_24: '#ec6c50',
      BETWEEN25_34: '#74c476',
      BETWEEN35_44: '#41b6c4',
      BETWEEN45_54: '#f48e57',
      BETWEEN55_64: '#ce6064',
      ABOVE64: '#8c83d4',
      YAXIS_TEXT: '#4d759e'
    },
    CHART_MARGINS: {
      TOP: 30,
      BOTTOM: 100
    },
    CHART_FONT_SIZE: {
      AXIS_LABEL: '10px',
      AXIS_TITLE: '12px'
    },
    FILTERS: filters,
    DURATION_DAYS: [{
      id: 'week',
      text: '7 Days'
    }, {
      id: 'month',
      text: '30 Days'
    }, {
      id: 'quarter',
      text: '12 weeks'
    }, {
      id: 'year',
      text: '12 months'
    }, {
      id: 'thisMonth',
      text: 'This Month'
    }],
    DURATION_ALL_VALUE: 'latest',
    DURATION_LAST_DAY_VALUE: 'day',
    MAX_XAXIS_LABELS: 16,
    GRANULARITY_ALL: 'all',
    DURATION_ALL: {
      id: 'latest',
      text: 'Latest'
    },
    DURATION_LAST_DAY: {
      id: 'day',
      text: 'Last Day'
    },
    LOCATION_POINTS_RESOLUTION: {
      MAJOR: 10,
      MINOR: 10
    },
    DEVICE_POINTS_RESOLUTION: {
      MAJOR: 10,
      MINOR: 10
    },
    PORTAL_POINTS_RESOLUTION: {
      MAJOR: 5,
      MINOR: 5
    },
    PLUGIN_POINTS_RESOLUTION: {
      MAJOR: 1,
      MINOR: 15
    },
    LOCATION_INTERVALS: [{
      min: 0,
      max: 100
    }, {
      min: 100,
      max: 1000
    }, {
      min: 1000,
      max: 10000
    }, {
      min: 10000,
      max: 100000
    }],
    DEVICE_INTERVALS: [{
      min: 0,
      max: 100
    }, {
      min: 100,
      max: 1000
    }, {
      min: 1000,
      max: 10000
    }, {
      min: 10000,
      max: 100000
    }],
    PORTAL_INTERVALS: [{
      min: 0,
      max: 25
    }, {
      min: 25,
      max: 50
    }, {
      min: 50,
      max: 100
    }],
    PLUGIN_INTERVALS: [{
      min: 0,
      max: null
    }]
  },
  /**
   * [CHART_METADATA The chart metadata; titles,axis names and colors for the charts.]
   * @type {Object}
   */
  CHART_METADATA: lang.i18n.CHART_METADATA
};
